import { SxProps, Typography } from '@mui/material';

export default function LoadingText({ text = 'Loading...', sx }: { text?: string; sx?: SxProps }) {
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', ...sx }}>
      {text}
    </Typography>
  );
}
